/* @generated */
import { THEME_CLASSES, GENERIC_THEME_CLASSNAME, DEFAULT_THEME } from "../design-tokens/dist/_constants/theme_classes.esm.js";
import classnames from "classnames";
const defaultTheme = DEFAULT_THEME.theme;
const defaultMode = DEFAULT_THEME.mode;
const getThemeClassname = (props) => {
  const { theme: themeName, mode: modeProp, isInverse, additionalClass } = props;
  const mode = isInverse ? getInverseMode(modeProp) : modeProp;
  return classnames(
    THEME_CLASSES[themeName]["modes"][mode].classList,
    GENERIC_THEME_CLASSNAME,
    additionalClass,
    {
      "dig-Theme--cancel-inverse": isInverse
    }
  );
};
const getInverseMode = (mode) => {
  return mode === "bright" ? "dark" : "bright";
};
const getThemeInfo = ({
  theme,
  mode,
  className,
  inverseClassName,
  styles,
  inverseStyles
}) => {
  return {
    // If `style` and `inverseStyles` are provided we can assume that the context has theme overrides.
    hasThemeOverrides: styles && inverseStyles ? true : false,
    mode,
    theme,
    getThemeProps: (overrides) => ({
      ...overrides,
      className: classnames(overrides && overrides.className, className),
      // conditionally add styles if they exist
      ...((overrides == null ? void 0 : overrides.style) || styles) && { style: { ...overrides == null ? void 0 : overrides.style, ...styles } }
    }),
    getInverseProps: (overrides) => ({
      ...overrides,
      className: classnames(overrides && overrides.className, inverseClassName),
      // conditionally add styles if they exist
      ...((overrides == null ? void 0 : overrides.style) || inverseStyles) && { style: { ...overrides == null ? void 0 : overrides.style, ...inverseStyles } }
    })
  };
};
const resolveThemeOverrides = ({
  currentOverride,
  existingOverride
}) => {
  if (currentOverride === "reset") {
    return null;
  }
  return currentOverride || existingOverride || null;
};
export {
  defaultMode,
  defaultTheme,
  getInverseMode,
  getThemeClassname,
  getThemeInfo,
  resolveThemeOverrides
};
